// Chrome island: giant-logo reveal.
//
// hd-redesign-p1 replaced the bottom-up clip wipe with the export's own reveal:
// the mark fades and rises from translateY(60px) scale(.96) over .9s on
// cubic-bezier(.22,.61,.36,1), observed at threshold 0.25. The reveal is
// REVERSIBLE — the export re-hides the mark when it leaves the viewport
// downward (boundingClientRect.top > 0, i.e. it went off the bottom), so
// scrolling back up plays it again.
//
// ── THIS FILE ARMS ITS OWN HIDDEN STATE ─────────────────────────────────────
// The band shipped BLANK because the pre-reveal state was gated on `.js-reveal`
// — a class assets/hd-reveal.js puts on <html>. That made the mark's hidden
// state depend on a DIFFERENT file succeeding, so every way THIS file could
// fail left the mark stranded at opacity 0 with nothing left to lift it. (The
// blank band had a second cause on top of that, a stale clip wipe in
// assets/hd-chrome.css; both are recorded in the CSS.)
//
// So `.is-armed` is added HERE, and it is the LAST thing done before observing.
// Read the order below as the contract: every early return happens BEFORE the
// class goes on. JS off, this file missing, a throw, no IntersectionObserver,
// prefers-reduced-motion — in all of them the section is never armed and
// assets/hd-p1.css leaves the mark plainly visible, because its base rules set
// no opacity and no transform.
//
// The observer watches the IMG (the section is the full-bleed band and
// intersects long before the mark does) but the state class goes on the
// SECTION, so one class releases the mark and the optional slogan together.
(function () {
  "use strict";

  // querySelectorAll, not querySelector: sections/hd-giant-logo.liquid carries a
  // preset, so the editor can add a second band, and the one this script missed
  // would be the one left behind. Each is armed and observed on its own.
  function all() {
    return Array.prototype.slice.call(document.querySelectorAll(".hd-giant-logo"));
  }

  function unarm() {
    all().forEach(function (sec) {
      sec.classList.remove("is-armed");
    });
  }

  function init() {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var sec = entry.target.closest(".hd-giant-logo");
          if (!sec) return;
          if (entry.isIntersecting) sec.classList.add("is-in");
          else if (entry.boundingClientRect.top > 0) sec.classList.remove("is-in");
        });
      },
      { threshold: 0.25 }
    );

    all().forEach(function (sec) {
      var el = sec.querySelector("img");
      if (!el) return;
      // Arm, then observe — never the other way round, and never before the
      // bail-outs in start(). If observe() throws, unarm rather than leave the
      // mark hidden for ever.
      sec.classList.add("is-armed");
      try {
        io.observe(el);
      } catch (err) {
        sec.classList.remove("is-armed");
      }
    });
  }

  function start() {
    // Checked here rather than at module scope: a bail-out must not be able to
    // happen after arming, and arming happens inside init().
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (reduced.matches || !("IntersectionObserver" in window)) return;
    try {
      init();
    } catch (err) {
      unarm();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
